<template>
  <div class="about-container pre-formatted">
    <div class="container" v-html="content">{{ content }}</div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "PrivacyPolicy",
  data() {
    return {
      content: ""
    };
  },
  methods: {
    ...mapActions("pages", ["fetchPageDetailsBySlug"])
  },
  mounted() {
    this.fetchPageDetailsBySlug("privacy-policy").then(res => {
      this.content = res.data.data;
    });
  }
};
</script>
<style lang="scss">

.pre-formatted {
  white-space: pre-wrap;
}



.about-container * {
  font-family: "Open Sans", sans-serif !important;
}
</style>
